import { FC } from 'react';
import ProBadge, { BadgeProps } from './badge';

export type IBadgeComponent = FC<BadgeProps>;

const TransBadge = ProBadge as IBadgeComponent;

export default TransBadge;
